/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Movement_Breakdown_Top_Table_TitleInputs */

const vi_movement_breakdown_top_table_title = /** @type {(inputs: Movement_Breakdown_Top_Table_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top biến động trong kỳ`)
};

/**

* @param {Movement_Breakdown_Top_Table_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const movement_breakdown_top_table_title = /** @type {((inputs?: Movement_Breakdown_Top_Table_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Movement_Breakdown_Top_Table_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_movement_breakdown_top_table_title(inputs)
});